import { render } from "./redirect-form.vue?vue&type=template&id=14dcab1c&scoped=true"
import script from "./redirect-form.vue?vue&type=script&lang=js"
export * from "./redirect-form.vue?vue&type=script&lang=js"

import "./redirect-form.vue?vue&type=style&index=0&id=14dcab1c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14dcab1c"]])

export default __exports__